import { observer } from "mobx-react";
import { Link } from "react-router-dom";

import Button from "components/UI/Button/Button";

import "./ReferralSection.scss";

const ReferralSection = observer(({ store, isMobile }) => {
  return (
    <section className="referral-section">
      {isMobile && <div className="referral-section-image" />}
      <div className="referral-section__description">
        <h3 className="section__title">до 60% от комиссии по реферальной программе</h3>
        <p className="section__text">Зарабатывайте и выводите деньги за регистрацию пользователей</p>
      </div>
      {!isMobile && <div className="referral-section-image" />}
      <Link to={store.isAuth ? "/referral" : "/signin"}><Button className="referral-section__button-link" title="Стать партнёром" /></Link>
    </section>
  );
});

export default ReferralSection;
